import { useEffect, useRef, useState } from "react";
import "../EventCard.css";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faMobileScreen, faRotate } from "@fortawesome/free-solid-svg-icons";
import { faCalendarCheck } from "@fortawesome/free-regular-svg-icons";
import { Tooltip } from "bootstrap";

dayjs.locale("es");

function EventCard({ event, cardWidth }) {
  const [flipped, setFlipped] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map((el) => new Tooltip(el));
  }, []);

  useEffect(() => {
    function handleClickOutside(e) {
      if (cardRef.current && !cardRef.current.contains(e.target)) {
        setFlipped(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={cardRef}
      style={{ width: cardWidth ? cardWidth : "300px" }}
      className={`card-container mx-4 ${flipped ? "flipped" : ""}`}
      onClick={() => setFlipped(!flipped)}
    >
      <div className="card border-0 bg-transparent">
        <div
          className="card-front add-img position-relative"
          style={{
            backgroundImage: `url(${event.images[0].url})`,
            aspectRatio: "2 / 3",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <span className="position-absolute bottom-0 end-0 p-1 bg-success text-light rounded fs-4">
            <FontAwesomeIcon icon={faRotate} />
          </span>
        </div>
        <div className="card-back bg-white">
          <p className="mb-0 fw-bold bg-success text-light">Ciudad: {event.city}</p>
          <div className="p-2">
            <h5>Detalles del evento</h5>
            <p style={{ fontSize: "13px" }} className="mb-1">
              {event.description}
            </p>
            {event.contacts.length > 0 && (
              <>
                <div>
                  <p className="mb-0">
                    Contacto: <span className="fw-bold">{event.contacts[0].name}</span>
                    <a className="btn btn-transparent" href={`tel:+${event.contacts[0].phone}`}>
                      <FontAwesomeIcon className="fs-3" style={{ color: "#4CAF50" }} icon={faMobileScreen} />
                    </a>
                  </p>
                </div>
                <small className="d-block">Llama y reserva tu lugar</small>
              </>
            )}
            {event.location && (
              <>
                <p className="mt-2 mb-0">
                  <span className="fw-bold">Ver mapa: </span>
                  <a
                    href={event.location}
                    target="_blanc"
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Ver ubicación en Google Maps"
                  >
                    <FontAwesomeIcon className="fs-4" style={{ color: "#c03600" }} icon={faLocationDot} />
                  </a>
                </p>
              </>
            )}
            {event.moreInfo && (
              <>
                <p className="mt-2">
                  <small>{event.moreInfo}</small>
                </p>
              </>
            )}
            {event.register && (
              <>
                <p className="mt-0">
                  <span className="fw-bold">Reserva tu lugar: </span>
                  <a
                    href={event.register}
                    target="_blanc"
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Reserva tu lugar"
                  >
                    <FontAwesomeIcon className="fs-4" style={{ color: "#c08d00" }} icon={faCalendarCheck} />
                  </a>
                </p>
              </>
            )}
          </div>
          <div className="bg-dark text-light position-absolute w-100 bottom-0 px-3 py-1">
            <h3>{event.name}</h3>
            {event.date &&
              (() => {
                const date = dayjs(event.date.substring(0, 10));
                return (
                  <>
                    {/* <small className="mb-0">{date.format("ddd")}</small> */}
                    <p className="mb-0 p-0">{date.format("ddd DD MMM")}</p>
                    {/* <small className="mb-0">{date.format("MMM")}</small> */}
                  </>
                );
              })()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventCard;
